import { render, staticRenderFns } from "./floorvalue.vue?vue&type=template&id=48b9edab&"
import script from "./floorvalue.vue?vue&type=script&lang=js&"
export * from "./floorvalue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48b9edab')) {
      api.createRecord('48b9edab', component.options)
    } else {
      api.reload('48b9edab', component.options)
    }
    module.hot.accept("./floorvalue.vue?vue&type=template&id=48b9edab&", function () {
      api.rerender('48b9edab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z2F5L93I5LCO/JS/comp/floorvalue.vue"
export default component.exports